<template>
  <div style="background: white">
    <h2 style="color: red">页面正在开发中[202011210745]</h2>
  </div>
</template>

<script>
export default {
  name: "error"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-error/error.vue